import React from "react";
import { Routes, Route } from "react-router-dom";
import RSVP from "./pages/RSVP";
import Preview from "./pages/Preview";
import EventNotFound from "./pages/EventNotFound";
import InvitationNotReady from "./pages/InvitationNotReady";
import useDocumentMeta from "./hooks/useDocumentMeta";

function App() {
  // Keeps <html lang> in sync with the active i18n language on every route,
  // so language-scoped CSS (greek-fonts.css) applies even on pages that
  // don't call useDocumentMeta themselves.
  useDocumentMeta();

  // Invitation URLs travel as path segments (never query strings) so
  // Referrer-Policy: strict-origin-when-cross-origin scrubs them on
  // cross-origin requests, less commonly logged by analytics, and not
  // surfaced by URL-preview fetchers. See F-AUTH-09.
  //
  //   /events/:slug                               — no codes (public preview)
  //   /events/:slug/r/:rsvpCode                   — per-guest RSVP code only
  //   /events/:slug/r/:rsvpCode/j/:joinCode       — RSVP + event join code
  //   /events/:slug/j/:joinCode                   — join code only (no RSVP)
  //
  //   /preview — the couple's own invitation, framed by their editor in app/;
  //              it draws what the editor sends and fetches nothing.
  return (
    <div className="app-wrapper">
      <Routes>
        <Route path="/events/:slug" element={<RSVP />} />
        <Route path="/events/:slug/r/:rsvpCode" element={<RSVP />} />
        <Route
          path="/events/:slug/r/:rsvpCode/j/:joinCode"
          element={<RSVP />}
        />
        <Route path="/events/:slug/j/:joinCode" element={<RSVP />} />
        <Route path="/events/:slug/not-ready" element={<InvitationNotReady />} />
        <Route path="/events/:slug/not-found" element={<EventNotFound />} />
        <Route path="/preview" element={<Preview />} />
        <Route path="*" element={<EventNotFound />} />
      </Routes>
    </div>
  );
}

export default App;
